<template>
  <v-container id="page-reservation-list">
    <div class="page-title">{{ $route.name }}</div>
    <v-row justify="space-between" class="mr-2">
      <v-col cols="12" md="2" sm="12">
        <c-card title="배차대기" outlined>
          <template #headItems>
            <c-btn
              class="red--text display-1"
              text
              @click="onClickFlag('receipt')"
              >{{ status.receiptCnt }}</c-btn
            >
          </template>
        </c-card>
      </v-col>
      <v-col cols="12" md="2" sm="12">
        <c-card title="예약완료" outlined>
          <template #headItems>
            <c-btn
              class="red--text display-1"
              text
              @click="onClickFlag('assigned')"
              >{{ status.reservCnt }}</c-btn
            >
          </template>
        </c-card>
      </v-col>
      <v-col cols="12" md="2" sm="12">
        <c-card title="이용중" outlined>
          <template #headItems>
            <c-btn
              class="red--text display-1"
              text
              @click="onClickFlag('driving')"
              >{{ status.drivingCnt }}</c-btn
            >
          </template>
        </c-card>
      </v-col>

      <v-col cols="12" md="6" sm="12">
        <v-row justify="end">
          <v-menu
            v-model="startMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <div style="width: 200px">
                <v-text-field
                  v-model="startDate"
                  label="시작일"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </div>
            </template>
            <c-date-picker
              v-model="startDate"
              @input="startMenu = false"
              firstDayOfWeek="1"
              :selectedDate="startDate"
              locale="ko-kr"
              :min="$func.dateStringAddMonths($func.stringToDate(endDate), -6)"
            ></c-date-picker>
          </v-menu>
          <v-menu
            v-model="endMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <div class="ml-5" style="width: 200px">
                <v-text-field
                  v-model="endDate"
                  label="종료일"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </div>
            </template>
            <c-date-picker
              v-model="endDate"
              @input="endMenu = false"
              firstDayOfWeek="1"
              :selectedDate="endDate"
              locale="ko-kr"
              :max="$func.dateStringAddMonths($func.stringToDate(startDate), 6)"
            ></c-date-picker>
          </v-menu>
        </v-row>
        <v-row justify="end">
          <div class="ml-5" style="width: 200px">
            <v-select
              v-model="searchType"
              :items="searchTypeList"
              label="검색타입"
              placeholder="신청 회원, 담당자"
              item-text="label"
              item-value="value"
            ></v-select>
          </div>

          <div class="ml-5" style="width: 200px">
            <v-text-field
              v-model="searchKeyword"
              label="검색어"
              :placeholder="keywordPlaceholder"
              prepend-icon="search"
              maxlength="32"
              @keyup="onSearch"
            ></v-text-field>
          </div>
        </v-row>
      </v-col>
    </v-row>
    <c-table
      :headers="reservationTableHeaders"
      itemKey="id"
      :items="reservationList"
      :page="pagination.page"
      :itemsPerPage="pagination.size"
      :totalElements="totalElements"
      @update:tableOptions="updateOption"
    >
      <template #vehicleCnt="{ item }">
        {{ item.vehicleCnt ? item.vehicleCnt : "-" }}
      </template>
      <template #state="{ item }">
        <c-reservation-state-chip
          :reservation="item"
          :reservation-state-event-flag="true"
          @onReReservation="onReReservation"
          @onChangeReservationState="onCancelDispatch"
        />
      </template>
      <template #plateNo="{ item }">
        {{ item.plateNo ? item.plateNo : "-" }}
      </template>
      <template #driverName="{ item }">
        {{ item.driverName ? item.driverName : "-" }}
      </template>
      <template #helpService="{ item }">
        {{ getHelpServiceInfo(item) }}
      </template>
      <template #detail="{ item }">
        <c-btn
          icon
          iconName="search"
          @click="onReservationDetail(item.reservationId)"
        />
      </template>
      <template #created="{ item }">
        <div>
          {{ dateFormatter(item.created) }}
        </div>
      </template>

      <template #fareType="{ item }">
        {{ getSuburbanString(item) }}
      </template>

      <template #point="{ item }">
        <div>
          <v-icon x-small color="light2Grey">place</v-icon>
          {{ item.departure }}
          <br />
          <v-icon x-small color="blue">place</v-icon>
          {{ item.destination }}
        </div>
      </template>

      <template #cancelComment="{ item }">
        {{ item.cancelComment ? item.cancelComment : "-" }}
      </template>
    </c-table>

    <!--자동배차 loading bar-->
    <v-dialog v-model="autoDialogOpen" hide-overlay persistent width="300">
      <c-card class="blue">
        <v-card-text>
          <div class="py-6 text-center white--text">
            자동 배차 중입니다.
          </div>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
            height="10"
          ></v-progress-linear>
        </v-card-text>
      </c-card>
    </v-dialog>

    <!--수동배차 dialog-->
    <manual-reserve-dialog
      :open.sync="manualDialogOpen"
      :reservationCheckData.sync="reservationCheckData"
      :reservationFlag.sync="reservationFlag"
    ></manual-reserve-dialog>

    <time-recommend-dialog
      :open.sync="timeRecoDialogFlag"
      :reservation-id="autoReservationId"
      :fail-time="failTime"
      :available-time-list="availableTimeList"
      @reqAutoReservation="reqAutoReservation"
    />
  </v-container>
</template>
<script>
import ManualReserveDialog from "../../CallTaxi/Reserve/ManualReserveDialog";
import TimeRecommendDialog from "@/views/CallTaxi/Reserve/TimeRecommendDialog";
import CReservationStateChip from "../../../components/CReservationStateChip";

export default {
  components: {
    CReservationStateChip,
    TimeRecommendDialog,
    ManualReserveDialog,
  },

  data() {
    return {
      searchType: "R_CUSTOMER_NAME",
      searchKeyword: "",
      startDate: this.$func.curDateString(),
      endDate: this.$func.curDateStringAddDays(7),
      startMenu: false,
      endMenu: false,
      receiptFlag: false,
      completeFlag: false,
      drivingFlag: false,
      status: {
        receiptCnt: 0,
        reservCnt: 0,
        drivingCnt: 0,
      },
      reservationFlag: null,
      reservationTableHeaders: [
        {
          text: "예약자",
          value: "customerName",
          align: "left",
          sortable: true,
        },
        {
          text: "예약 날짜",
          value: "created",
          align: "center",
          sortable: true,
        },
        {
          text: "출발 시간",
          value: "startDateTime",
          align: "center",
          sortable: true,
        },
        {
          text: "출발지 / 도착지",
          value: "point",
          align: "left",
          sortable: false,
        },
        {
          text: "예약 인원",
          value: "customerCnt",
          align: "center",
          sortable: true,
        },
        {
          text: "담당 차량",
          value: "plateNo",
          align: "center",
          sortable: true,
        },
        {
          text: "담당 기사",
          value: "driverName",
          align: "center",
          sortable: true,
        },
        {
          text: "진행 상황",
          value: "state",
          align: "center",
          sortable: false,
        },
        {
          text: "도움 서비스",
          value: "helpService",
          align: "center",
          sortable: false,
        },
        {
          text: "비고",
          value: "cancelComment",
          align: "center",
          sortable: false,
          width: "143",
        },
        {
          text: "상세보기",
          value: "detail",
          align: "center",
          sortable: false,
        },
      ],
      reservationList: [],
      manualDialogOpen: false,
      autoDialogOpen: false,
      reservationInfo: [],
      dataTableItemList: [],

      reservationCheckData: {},

      timeRecoDialogFlag: false,
      autoReservationId: "",
      autoReservationFlag: false,
      availableTimeList: [],
      failTime: "",
      filteringType: "",
      searchTypeList: [
        {
          label: "고객명",
          value: "R_CUSTOMER_NAME",
        },
        {
          label: "기사이름",
          value: "DRIVER_NAME",
        },
      ],
      pagination: {
        page: 1,
        size: 10,
        sort: "",
      },
      totalElements: 0,
    };
  },
  watch: {
    startDate: function() {
      this.reqGetReservationList();
    },
    endDate: function() {
      this.reqGetReservationList();
    },
    reservationFlag(newVal) {
      if (newVal && newVal === "success") {
        // 수동 배차 후
        this.reqGetReservationList();
      }
    },
  },
  activated() {
    this.reqGetReservationList();
  },
  computed: {
    keywordPlaceholder() {
      return this.searchType === "R_CUSTOMER_NAME" ? "고객명" : "기사이름";
    },
  },
  methods: {
    onClickFlag(flag) {
      if (this.filteringType === flag) {
        this.filteringType = "";
      } else {
        this.filteringType = flag;
      }
      this.reqGetReservationList();
    },

    async reqReservation(reservationId) {
      try {
        const res = await this.$api.getReservationWithPassengers(reservationId);
        this.reservationInfo = res.data.reservationList;
        this.reservationCheckData = res.data;
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqReservation" });
      }
    },
    async reqGetReservationList() {
      try {
        const params = {
          ...this.pagination,
          searchType: this.searchType,
          searchKeyword: this.searchKeyword,
          filteringType: this.filteringType,
        };

        const res = await this.$api.getReservationPeriod(
          this.startDate,
          this.endDate,
          params
        );

        this.reservationList = res.data.list.content;
        this.status = res.data.stat;
        this.totalElements = res.data.list.totalElements;
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqGetReservationList" });
      }
    },
    onReservationDetail(data) {
      this.$router.push(`/reservation/${data}`);
    },
    dateFormatter(date) {
      return this.$moment(date).format("YYYY-MM-DD");
    },
    setChipsColor(data) {
      if (data === "rs_complete") {
        // 예약완료 -> rs_complete
        return "light1Green";
      } else if (data === "rs_driving") {
        //이용중
        return "blue";
      } else if (data === "rs_done") {
        //이용완료
        return "light2Blue";
      } else if (data === "rs_cancel") {
        //예약취소
        return "light2Grey";
      } else if (data === "rs_receipt") {
        //배차대기
        return "light1Red";
      } else if (data === "rs_assign") {
        //배차대기
        return "light1Red";
      }
    },
    async onReReservation(type, reservation) {
      const reservationId = reservation.reservationId;
      const startDateTime = reservation.startDateTime;

      if (type === "auto") {
        if (this.$moment(reservation.startDateTime).isBefore(this.$moment()))
          this.$store.commit("snackbar", {
            msg: "과거 시간은 자동배차가 불가능합니다.",
          });
        else await this.reqAutoReservation(reservationId, startDateTime);
      } else {
        await this.reqReservation(reservationId);
        this.manualDialogOpen = true;
      }
    },
    async reqAutoReservation(rId, startDateTime) {
      this.autoDialogOpen = true;

      let reqData = {
        reservationId: rId,
        startDateTime: startDateTime,
        centerId: this.$store.state.centerInfo.centerId,
      };

      try {
        const { data } = await this.$api.autoReservation(reqData);
        const { isAssignSuccess, reservableList, reservationList } = data;

        // 자동배차 실패 인 경우
        if (!isAssignSuccess) {
          // 가능한 시간이 없을 경우
          if (reservableList.length < 1) {
            this.$store.commit("alert", {
              err: true,
              where: "reqAutoReservation",
              open: true,
              persistent: true,
              msg:
                "배차 가능한 차량이 없습니다.\n" + "예약시간을 확인해 주세요.",
            });
            this.autoDialogOpen = false;
            return;
          }

          // 가능한 시간 팝업
          this.autoDialogOpen = false;
          this.autoReservationId = rId;
          this.failTime = startDateTime;
          this.availableTimeList = reservableList.map((item) => {
            let newItem = {};
            newItem.text = this.$moment(item.date).format("HH:mm");
            newItem.value = item.date;
            return newItem;
          });

          this.timeRecoDialogFlag = true;
        } else {
          this.autoDialogOpen = false;
          await this.reqGetReservationList();

          this.timeRecoDialogFlag = false;

          this.$store.commit("snackbar", {
            color: "blue",
            timeout: 2000,
            msg: "예약이 완료되었습니다.",
          });
        }
      } catch (err) {
        // 네트워크 에러일 때
        this.$store.commit("alert", {
          err,
          where: "reqAutoReservation",
          open: true,
          persistent: true,
          msg: "자동배차에 실패했습니다.",
        });

        this.autoDialogOpen = false;
      }
    },
    onCancelDispatch(state, rowReservation) {
      if (state === "rs_receipt") {
        this.$store.commit("alert", {
          open: true,
          persistent: true,
          msg: "배차 대기 상태로 변경하시겠습니까?",
          confirm: true,
          callBack: async () => {
            let reservationId = rowReservation.reservationId;

            const reqData = {
              reservationId: reservationId,
              configString: state,
            };
            this.reqChangeReservationState(reqData);
          },
        });
      }
    },
    async reqChangeReservationState(data) {
      try {
        await this.$api.changeReservationState(data);
        await this.reqGetReservationList();
        this.$store.commit("alert", {
          open: true,
          persistent: true,
          msg: "취소 되었습니다.",
        });
      } catch (err) {
        this.$store.commit("snackbar", {
          err,
          where: "reqChangeReservationState",
        });
      }
    },
    getSuburbanString(item) {
      // 시내 / 시외만 구분
      if (!item || !item.fareType) {
        return "";
      }

      return item.fareType.startsWith("suburban") ? "시외" : "시내";
    },
    getHelpServiceInfo(item) {
      if (!item?.helpService) {
        return "-";
      }
      try {
        const { isMatching } = JSON.parse(item.helpService);
        return isMatching ? "병원동행" : "병원동행(미배정)";
      } catch (e) {
        return "-";
      }
    },
    updateOption(option) {
      this.pagination.page = option.page;
      this.pagination.size = option.itemsPerPage;
      if (option.sortBy.length > 0 && option.sortDesc.length > 0) {
        this.pagination.sort = `${option.sortBy[0]},${
          option.sortDesc[0] ? "asc" : "desc"
        }`;
      }
      this.reqGetReservationList();
    },
    onSearch(event) {
      if (event.key === "Enter") {
        this.pagination.page = 1;
        this.reqGetReservationList();
      } else {
        return;
      }
    },
  },
};
</script>
<style scoped></style>
